module.exports = __webpack_public_path__ + "files/35705ffae1ea0b1e1b40cce71d3c2e34.woff2";


//////////////////
// WEBPACK FOOTER
// ./non_npm_dependencies/google-fonts/fonts/arvo-italic-webfont.woff2
// module id = 804
// module chunks = 60